import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Collapse from '@mui/material/Collapse'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

interface Props {
  children: React.ReactNode
  height?: number
}

const RevealCard = ({children, height = 250, ...props}: Props) => {
  const [open, toggleOpen] = React.useState(false)
  return (
    <Card elevation={0} sx={{background: '#fff'}} {...props}>
      <CardContent>
        <Collapse in={open} collapsedSize={height}>
          {children}
        </Collapse>
        <Box sx={{textAlign: 'center'}}>
          <Button
            sx={{textTransform: 'capitalize', margin: '0 auto -1rem'}}
            onClick={() => toggleOpen(!open)}
          >
            See {open ? 'less' : 'more'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default RevealCard
